import React, { useEffect } from 'react';
import './MesaPage.css';

const KtpPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="mesa-page">
      <div className="mesa-content">
        <div className="mesa-text">
          <h1 className="mesa-title">
            <a href="https://knowthatplane.com" target="_blank" rel="noopener noreferrer">Know That Plane<svg className="mesa-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg></a>
          </h1>
          <p className="mesa-description">
            A flight tracking prototype that reveals a plane's past. Enter an aircraft's tail number--its "license plate"--and the site traces recent routes the aircraft has flown, plotted across an interactive globe.
          </p>
        </div>
      </div>

      <div className="mesa-features">
        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Concept</h2>
            <p className="mesa-feature-description">
              Most flight tools are built around routes or airports, but I wanted the aircraft itself to be the subject. As such, the landing page keeps the focus narrow with a simple text field and a rotating globe with example routes animating over it. </p>
          </div>
          <div className="mesa-feature-image">
            <img
              src="/KTPHero.png"
              alt="Know That Plane landing page"
              className="mesa-feature-img"
            />
          </div>
        </div>

        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Plane Profile</h2>
            <p className="mesa-feature-description">
              Every aircraft displays a photo, its model, its registry, when it was delivered, how many flights it's logged, and how many hours it's been in the air. Its recent routes sit below as a chronological list. 
            </p>
          </div>
          <div className="mesa-feature-image">
            <img
              src="/PlaneDetail.png"
              alt="Know That Plane aircraft profile view"
              className="mesa-feature-img"
            />
          </div>
        </div>

        <div className="mesa-feature">
          <div className="mesa-feature-text">
            <h2 className="mesa-feature-title">Route Detail</h2>
            <p className="mesa-feature-description">
                Selecting a flight zooms the globe to a regional map, plotting the route arc from origin to destination. Key details—times, duration, and aircraft info—appear as a digital ticket stub, while the sidebar preserves your flight history for quick switching.            </p>
          </div>
          <div className="mesa-feature-image">
            <img
              src="/RouteDetail.png"
              alt="Know That Plane route detail view"
              className="mesa-feature-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KtpPage;
